var React = require('react');

function Chat360px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M59.295 59.955a1.005 1.005 0 0 1-1.121-.393l-6.47-9.511H22.012A5.017 5.017 0 0 1 17 45.04v-9.041a1 1 0 0 1 2 0v9.041a3.015 3.015 0 0 0 3.012 3.01h30.221c.032 0 .059.015.09.018.069.007.134.02.2.041a.91.91 0 0 1 .328.174c.053.043.1.088.143.14.021.025.048.039.067.065L58 55.751V24.012A3.015 3.015 0 0 0 54.988 21H48a1 1 0 1 1 0-2.001h6.988A5.018 5.018 0 0 1 60 24.012V59a1 1 0 0 1-.705.955zM37.988 31.051H8.295l-6.468 9.511a1.003 1.003 0 0 1-1.121.394A1.002 1.002 0 0 1 0 39.999V5.011A5.017 5.017 0 0 1 5.012 0h32.976A5.017 5.017 0 0 1 43 5.011v21.028a5.018 5.018 0 0 1-5.012 5.012zM41 5.011a3.016 3.016 0 0 0-3.012-3.012H5.012A3.015 3.015 0 0 0 2 5.011v31.74l4.94-7.263c.018-.026.045-.04.065-.064a.967.967 0 0 1 .145-.141.88.88 0 0 1 .327-.174.994.994 0 0 1 .201-.04c.031-.003.057-.018.089-.018h30.221A3.016 3.016 0 0 0 41 26.039V5.011z","key":1})]);
}

Chat360px.displayName = "Chat360px";

Chat360px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 60 60"};

module.exports = Chat360px;

Chat360px.default = Chat360px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/60px/chat-3-60px.svg
// module id = 1185
// module chunks = 0